// React
import { ReactElement } from 'react';
// Utils
import { useTranslation } from 'next-i18next';
// Interfaces
import { StatView } from '@utmb/types/index';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Styles
import styles from './races-list.module.scss';
import { KeyFigure } from '@utmb/features/key-figures/KeyFigure';

interface StatProps extends StatView {
    raceTheme?: string;
    isDark?: boolean;
}

const Stat = (props: StatProps): ReactElement => {
    const { name } = props;
    const { t } = useTranslation();

    return (
        <div className={styles.stat}>
            <Font.OxaniumBold mobile="12" desktop="14" className={styles.stat_label}>
                {t(`races.keyfigures.${name}`)}
            </Font.OxaniumBold>
            <Font.OxaniumBold mobile="18" desktop="20" as="span">
                <KeyFigure {...props} />
            </Font.OxaniumBold>
        </div>
    );
};

export default Stat;
